/**
 * Placeholder group label until programme groups are loaded from the API.
 */

export const PLACEHOLDER_PROGRAMME_GROUP_LABEL = 'Group A';

export const SELECT_LEARNER_FIRST_PLACEHOLDER = 'Select a learner first';
